import { useCursorOverride } from './useCursorOverride';
import { useMouseEventHandlers } from './use-mouse-event-handlers';

export const useMapCursor = () => {
  useMouseEventHandlers();
  useCursorOverride();
};
